import {
  ApiAppNamespaces,
  ApiBackofficeNamespaces,
  IQueuedRequest,
  OneAPIOptions
} from '../../common'
import { AnalyticsAppApi } from './app'
import { AnalyticsBackofficeApi } from './backoffice'
import { Queue } from '../../queue'

export class AnalyticsApp implements ApiAppNamespaces {
  app: AnalyticsAppApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.app = new AnalyticsAppApi(name, sessionId, requestsQueue, options)
  }

  invalidateAll() {
    this.app.invalidateAll()
  }
}

export class AnalyticsBackoffice implements ApiBackofficeNamespaces {
  backoffice: AnalyticsBackofficeApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.backoffice = new AnalyticsBackofficeApi(
      name,
      sessionId,
      requestsQueue,
      options
    )
  }

  invalidateAll() {
    this.backoffice.invalidateAll()
  }
}
